import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { Link, Route, Routes } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import { useTranslation } from 'react-i18next';
import usePages from '../usePages';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const PrestigeLevelsMainPage = () => {
  const { t } = useTranslation();
  const { loading, columns, data, onChangeTableFilter, handleDeleteCategory } =
    usePages();
  const pages = useRecoilValue(getPage);

  return (
    <>
      <PageHeader title={t('TESTI MYSHOP').toUpperCase()}>
        {pages?.ability?.can_create && (
          <Link to={'new'}>
            <Button width={'138px'} big icon={<PlusOutlined />}>
              {t('NUOVO')}
            </Button>
          </Link>
        )}
      </PageHeader>
      <div className={styles.container}>
        <Table
          columns={columns}
          dataSource={data.pages}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal
              onClickDelete={handleDeleteCategory}
              loading={loading}
            />
          }
        />
      </Routes>
    </>
  );
};

export default PrestigeLevelsMainPage;
